// JavaScript Document
//components/configuration/standard/Config.js
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
//import Schedule from './tabs/Schedule';
//import Events from './tabs/Events';
import Messages from './tabs/Messages';
import Advanced from './tabs/Advanced';
import Calendar from './tabs/Calendar';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import SwapIcon from '@material-ui/icons/SwapHoriz';
import IconMenu from '@material-ui/icons/Menu';
import IconDownload from '@material-ui/icons/GetApp';
import Picker from './Picker';
import dsutils from './daysettings/Utils';
//import Display from '../display/Display';
import { Menu, MenuItem, ListItemIcon, ListItemText, IconButton } from '@material-ui/core';
const utils = dsutils();

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={{xs: 0, sm: 2, md: 3}}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}//`


TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}




const useStyles = makeStyles((theme) => ({
	root: {
    	flexGrow: 1,
    	width: '100%',
	  	//backgroundColor: theme.palette.background.default,
  	},
	configHeader: {
		display: "flex",
		flexGrow: 1,
		flexDirection: 'row'
	},
	nameDescription: {
		display: "flex",
		flexGrow: 1,
		flexDirection: 'column'
	},
	saveButton: {
		margin: theme.spacing(1),
	},
  	tabContent : {
	  	flexGrow: 1,
	  	width: '100%',
	  	backgroundColor: theme.palette.background.paper,
  	},
	discreetInput : {
		transition: theme.transitions.create(['border-color', 'box-shadow']),
		'&:hover':{
			backgroundColor:theme.palette.background.paper
		}
	},
	largeFont : {
		fontSize: '1.3em',
		fontWeight: 'bold'
	},
	pos: {
		marginBottom:12,
	},
}));

export default function Config(props) {
  	const classes = useStyles();
	const { sign, handleSend, onChange } = props;
  	const [value, setValue] = React.useState(0);
	const [loaded, setLoaded] = React.useState(false);
	const [userChanged, setUserChanged] = React.useState(false);
	const [saveLabel, setSaveLabel] = React.useState('Save Configuration');
	const [loadedToken, setLoadedToken] = React.useState(Date.now());
	//const [displays, setDisplays] = React.useState({});
	const [configsLoaded, setConfigsLoaded] = React.useState(false);
	const [configList, setConfigList] = React.useState([]);
	//const [selectedConfig, setSelectedConfig] = React.useState({});
	const [pickerOpen, setPickerOpen] = React.useState(false);
	const [configMenuAnchor, setConfigMenuAnchor] = React.useState(null);
	const [ config, setConfig ] = React.useState(
		{
			daysettings : {
				"0" : utils.model.daysetting
			},
			id: 0,
			name: 'Configuration',
			description: 'loading...',
			special_events: [],
			sunday : 0,
			monday : 0,
			tuesday : 0,
			wednesday : 0,
			thursday : 0,
			friday : 0,
			saturday : 0,
			pixel_maps : {}
		}
	);
	//Refresh load
	React.useEffect(() => {
		if(!loaded || config.id !== sign.primary_config){
			getConfig();
		}
		if(!configsLoaded){
			getConfigList();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);

	const menuOrigin = {
		vertical : 'top',
		horizontal : 'right'
	}
	
	const noMessage = !(sign.sign_type_obj && sign.sign_type_obj.opt_width && sign.sign_type_obj.opt_height);
	
	//update config
	const handleUpdateConfig = (newConfig) => {
		setConfig(newConfig);
		setUserChanged(true);
	}
	
	//handle basic value change
	const handleChangeBase = (e) => {
		let name = e.target.name;
		let value = e.target.value;
		let newConfig = Object.assign({}, config);
		newConfig[name]=value;
		handleUpdateConfig(newConfig);
	}
	//load list of configs
	const getConfigList = () => {
		setConfigsLoaded(true);
		handleSend({
			vso: 'config_standard',
			config: sign.primary_config,
			subaction: 'config_list'
		}, (data) => {
			setConfigList(data.config.config_list);
			if(!sign.primary_config)
				setPickerOpen(true);
		});
	}
	
  	//load config from server
  	const getConfig = (id) =>{
	  	setLoaded(true);
		if(sign.primary_config || id){
			//setConfigsLoaded(true);
	  		handleSend({
		  		vso: 'config_standard',
		  		config: (id || sign.primary_config),
				//subaction: 'config_list'
	  		}, (data) => {
				//if(data.config.id)
		  		setConfig(data.config);
				//setDisplays(renderDisplays(data.config.pixel_maps));
		  		console.log(data.config);
				setLoadedToken(Date.now());
			});
		} else {
			setConfig(Object.assign(config, {name: 'No Configuration Selected', description: 'Please select a configuration'}))
		}
  	}
	
	//Change selected tab
  	const handleChange = (event, newValue) => {
    	setValue(newValue);
  	};
	
	//Handle save action
	const handleSave = (e) => {
		setSaveLabel('Saving');
		console.log("Save button clicked!");
		handleSend({
			vso: 'config_standard',
			config: config,
			subaction: 'save'
		}, (data) => {
			console.log(data);
			setUserChanged(false);
			setSaveLabel('Save Configuration');
			if(config.id !== data.config.id){
				if(onChange)
					onChange({primary_config: data.config.id});
			}
			setConfig(data.config);
			
		});
	}
	
	//handle click change button
	const handleClickChange = (e) => {
		//console.log('you want to change the config');
		closeConfigMenu();
		setPickerOpen(true);
	}
	
	
	//renders the save button if changes have been made
	const renderSave = () => {
		if(userChanged){
			return (
				<Button 
					variant="contained" 
					color="secondary" 
					onClick={handleSave} 
					endIcon={<SaveIcon />}
					className={classes.saveButton}
					size="large"
					disabled={saveLabel==='Saving' ? true : false}
				>
					{saveLabel}
				</Button>
			);
		}
		return "";
	}
	
	//Function to run when closing configuration picker
	const configSelected = (opt) => {
		setPickerOpen(false);
		if(opt.id){
			if(onChange){
				onChange({ primary_config: opt.id})
			}
			getConfig(opt.id);
		}
	};

	const closeConfigMenu = (e) => {
		setConfigMenuAnchor(null);
	}

	const handleDownloadPRI = (e) => {
		let filename = [
			'sign',
			sign.id,
			'config',
			config.id,
			'PRI0000.CFG'
		].join('_');
		//fetch this to compile configuration
		let compileCFGURL = window.location.origin+
			'/needs/vspeedOnline/autoFileToDb.php?'+
			'action=SaveToFile&sign_id='+sign.id+
			'&config_id='+config.id+
			'&file='+filename;
		//URL of compiled configuration file
		let CFGLocation = window.location.origin + 
			'/needs/vspeedOnline/' + filename;
		//compile the configuration
		fetch(compileCFGURL).then((res) => {
			//load compiled configuration file
			fetch(CFGLocation).then(pri => {
				//convert to blob
				pri.blob().then(blob => {
					//push blob content as download to browser
					let url = window.URL.createObjectURL(blob);
					let a = document.createElement('a');
					a.href = url;
					a.download = 'PRI0000.CFG';
					a.click();
				});
			});	
		});
		
		closeConfigMenu();
	}

	const configtabs = [
		{
			name : 'Schedule',
			content : (
				<Calendar sign={sign} handleSend={handleSend} onChange={handleUpdateConfig} config={config} loadedToken={loadedToken}>
					{loadedToken}
				</Calendar>
			)
		}, 
		
		/* {
			name : 'Schedule',
			content : (
				<Schedule sign={sign} onChange={handleUpdateConfig} config={config} loadedToken={loadedToken}>
					{loadedToken}
				</Schedule>
			)
		}, 
			*/
		{
			name : 'Details',
			content : (
				<Advanced sign={sign} onChange={handleUpdateConfig} config={config} loadedToken={loadedToken}>
					{loadedToken}
				</Advanced>
			)
		}, {
			name : 'Messages',
			content : (
				<Messages sign={sign} handleSend={handleSend} onChange={handleUpdateConfig} config={config} loadedToken={loadedToken}>
					{loadedToken}
				</Messages>
			)
		}, /*
		, {
			name: 'Events',
			content : (
				<Events sign={sign} handleSend={handleSend} onChange={handleUpdateConfig} config={config} loadedToken={loadedToken}>
					{loadedToken}
				</Events>
			)
		}
		*/
	];

	const finaltabs = () => {
		if(noMessage) return configtabs.filter(n => n.name.toLowerCase() !== 'messages');
		return configtabs;
	}
	
  	return (
    	<div className={classes.root}>
			<Menu
				id="config-menu"
				anchorEl={configMenuAnchor}
				anchorOrigin={menuOrigin}
				keepMounted
				transformOrigin={menuOrigin}
				open={Boolean(configMenuAnchor)}
				onClose={closeConfigMenu}
				>
					<MenuItem onClick={handleDownloadPRI}>
						<ListItemIcon><IconDownload /></ListItemIcon>
						<ListItemText>Download configuration file (PRI)</ListItemText>
					</MenuItem>
					<MenuItem onClick={handleClickChange}>
						<ListItemIcon><SwapIcon /></ListItemIcon>
						<ListItemText>Choose a different configuration</ListItemText>
					</MenuItem>
				</Menu>
			<Box p={{xs: 0, sm: 1, md:2}}>
			<Box className={classes.configHeader}>
				<Box className={classes.nameDescription}>
					<TextField
						id="configName"
						label=""
						name="name"
						value={config.name}
						InputProps={{
							disableUnderline:true,
							classes: {
								input: classes.largeFont
							}
						}}
						inputProps={{maxLength: 25}}
						className={classes.discreetInput}
						onChange={handleChangeBase}
						size="medium"
						fullWidth
					/>
	  				<TextField
						id="configDescription"
						label=""
						name="description"
						className={classes.discreetInput}
						InputProps={{disableUnderline:true}}
						value={config.description}
						onChange={handleChangeBase}
						size="small"
						fullWidth
					/>
				</Box>
				{renderSave()}
				<IconButton 
					color='default' 
					variant='contained' 
					onClick={(e) => setConfigMenuAnchor(e.currentTarget)}
				>
					<IconMenu />
				</IconButton>
			</Box>
      	<AppBar position="static" color="default">
        	<Tabs
          		value={value}
          		onChange={handleChange}
          		indicatorColor="primary"
          		textColor="primary"
          		variant="scrollable"
          		scrollButtons="auto"
          		aria-label="scrollable auto tabs example"
        	>
				{finaltabs().map((t, i) => (<Tab key={i} label={t.name} {...a11yProps(i)} />))}
          		
        	</Tabs>
      	</AppBar>
		{finaltabs().map((t, i) => (
			<TabPanel value={value} index={i} key={i} className={classes.tabContent}>
				{t.content}
			</TabPanel>
		))}

      
		</Box>
		<Picker open={pickerOpen} onClose={configSelected}
		// selectedValue={selectedConfig} 
		 items={configList} />
    </div>
  );
}
